import { useNavigate } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import CyberLayout from '@/components/CyberLayout';
import InstallBanner from '@/components/InstallBanner';
import { ArrowRight, Lock } from 'lucide-react';
import { useEffect, useState } from 'react';

export default function LandingPage() {
  const navigate = useNavigate();
  const { t } = useLanguage();
  const [hasAccess, setHasAccess] = useState(false);

  useEffect(() => {
    // Check if user already has access
    const accessCode = sessionStorage.getItem('accessCode');
    setHasAccess(!!accessCode);
  }, []);

  const handleStart = () => {
    const accessCode = sessionStorage.getItem('accessCode');
    if (accessCode) {
      navigate('/privacy');
    } else {
      navigate('/access');
    }
  };

  return (
    <CyberLayout>
      {/* Mobile Install Banner */}
      <InstallBanner />
      
      <div className="min-h-screen flex flex-col items-center justify-center px-6 py-20">
        {/* Smart Info Logo */}
        <div className="relative mb-12 fade-in-up text-center">
          {/* Logo Image */}
          <img 
            src="/logo-white.svg" 
            alt="Smart Info - Agenzia Investigativa" 
            className="h-24 sm:h-28 lg:h-32 mx-auto"
            data-testid="landing-logo"
          />
          
          {/* Decorative line */}
          <div className="mt-6 mx-auto w-32 h-0.5 bg-gradient-to-r from-transparent via-red-500 to-transparent" />
        </div>

        {/* Subtitle */}
        <p 
          className="font-mono text-neon-cyan text-base lg:text-lg mb-16 tracking-widest uppercase text-center fade-in-up"
          style={{ animationDelay: '0.2s' }}
        >
          {t('subtitle')}
        </p>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-6 fade-in-up" style={{ animationDelay: '0.3s' }}>
          <button
            onClick={handleStart}
            data-testid="start-investigation-btn"
            className="cyber-btn px-8 py-4 text-lg flex items-center gap-3 glitch"
          >
            <span>{t('startInvestigation')}</span>
            <ArrowRight className="w-5 h-5" />
          </button>
        </div>

        {/* Access status indicator */}
        {hasAccess && (
          <div className="mt-6 flex items-center gap-2 px-4 py-2 rounded-full bg-neon-green/10 border border-neon-green/30 fade-in-up" style={{ animationDelay: '0.4s' }}>
            <Lock className="w-4 h-4 text-neon-green" />
            <span className="font-mono text-xs text-neon-green">Accesso autorizzato</span>
          </div>
        )}

        {/* Decorative Elements */}
        <div className="absolute bottom-10 left-10 font-mono text-xs text-neon-green/50 hidden md:block">
          <div>SYS.READY</div>
          <div>v2.0.4</div>
        </div>
        
        <div className="absolute bottom-10 right-10 font-mono text-xs text-neon-cyan/50 hidden md:block text-right">
          <div>SECURE_PROTOCOL</div>
          <div>ENCRYPTED</div>
        </div>
      </div>
    </CyberLayout>
  );
}
